import API from "@/services/api";
import { IPowerChangeSucessResponse, ISendPowerChangeParams, SendPowerChangeAPIParams } from "../types/power";

export enum EndpointName {
  ChangePower = '/contracts/:contractName/power/',
}

const sendPowerChange = ({
  contractName,
  value
}: ISendPowerChangeParams) => {

  return API.post<IPowerChangeSucessResponse, SendPowerChangeAPIParams>({
    endpoint: EndpointName.ChangePower,
    data: value,
    params: {
      contractName
    }
  });
}

export default {
  sendPowerChange,
};